import { z } from 'zod';

export const collectionClassSchema = z.object({
  content_type: z.literal('class'),
  image: z.string().optional(),
  position: z.number(),
  item_source: z.string(),
  item_title: z.string(),
  item_key: z.string(),
  class_type: z.string().optional(),
  event_name: z.string().optional(),
  taxonomy: z.array(z.any()).optional(),
  url: z.string().optional(),
  collection_id: z.string(),
});

export const collectionArticleSchema = z.object({
  content_type: z.literal('article'),
  image: z.string().optional(),
  position: z.number(),
  item_source: z.string(),
  item_title: z.string(),
  taxonomy: z.array(z.any()).optional(),
  item_key: z.string(),
  url: z.string().optional(),
  collection_id: z.string(),
  cms: z.string().optional(),
});

export const collectionBookmarkSchema = z.object({
  item_key: z.string(),
  item_source: z.string(),
  item_title: z.string(),
  description: z.string().optional(),
  position: z.number().optional(),
  content_type: z.string().optional(),
});

export const collectionItemSchema = z.union([
  collectionArticleSchema,
  collectionClassSchema,
  collectionBookmarkSchema,
]);

export const collectionItemArraySchema = z.array(collectionItemSchema);
